import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ISquadsStore} from "data/stores/squads/squds.store";
import type {ISquad, IPastFixture} from "data/types/api";
import {filter, find} from "lodash";

interface IProps {
	homeSquadId: number;
	awaySquadId: number;
}

export interface IStatsController extends ViewController<IProps> {
	homeSquadId: number;
	awaySquadId: number;

	get stats(): [];
	get pastFixtures(): IPastFixture[];
	get homeSquad(): ISquad | undefined;
	get awaySquad(): ISquad | undefined;
}

@injectable()
export class StatsController implements IStatsController {
	@observable homeSquadId: number = 0;
	@observable awaySquadId: number = 0;

	constructor(@inject(Bindings.SquadsStore) private _squadsStore: ISquadsStore) {
		makeAutoObservable(this);
	}

	get stats(): [] {
		return [];
	}

	get pastFixtures() {
		return filter(this.homeSquad?.stats.pastFixtures, (item) => {
			return Boolean(
				find(item.scores, (value, key) => parseInt(key, 0) === this.awaySquad?.id)
			);
		});
	}

	dispose(): void {
		return;
	}

	init({homeSquadId, awaySquadId}: IProps): void {
		this.homeSquadId = homeSquadId; //this._squadsStore.getSquadById(homeSquadId);
		this.awaySquadId = awaySquadId; //this._squadsStore.getSquadById(awaySquadId);
	}

	get homeSquad(): ISquad | undefined {
		return this._squadsStore.getSquadById(this.homeSquadId);
	}

	get awaySquad(): ISquad | undefined {
		return this._squadsStore.getSquadById(this.awaySquadId);
	}
}
